import { UndoRedoService } from '@src/slide/application/service/undo-redo-service';
import { IUndoRedoService } from '@src/slide/application/service/undo-redo-service/undo-redo-service.interface';
import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import { IBaseEditableServiceLayer } from './base-editable-service-layer.interface';
import { IBaseViewableServiceLayer } from './base-viewable-service-layer.interface';
import { ICopyPasteImageService } from '@src/slide/application/service/copy-paste/copy-paste.interface';
import { DynamicServiceLoader, IDynamicService } from '@src/slide/infrastructure/module/independent/dynamic-loader/dynamic-service';
import { copyPasteImageServiceDynamicConfig } from './service-dynamic-configs/copy-paste.config';
import { IMenuManager } from '@src/slide/application/service/menu-manager/menu-manager.interface';
import MenuManager from '@src/slide/application/service/menu-manager';
import AdvancePermissionManager from '@src/slide/application/service/advanced-permission/core';
import {
    IAdvancedPermissionInjectable,
    IAdvancedPermissionManager,
} from '@src/slide/application/service/advanced-permission/core/interface';
import AdvancedPermissionInjectable
    from '@src/slide/application/service/advanced-permission/inject/toc/advanced-permission-injectable';
import { ISyncFileManager } from '@src/slide/application/service/sync-file/core/sync-file-manager.interface';
import SyncFileManager from '@src/slide/application/service/sync-file/core';

export class BaseEditableServiceLayer implements IBaseEditableServiceLayer {
    public readonly undoRedoService: IUndoRedoService;
    public readonly menuManager: IMenuManager;
    public readonly advancedPermissionManager: IAdvancedPermissionManager;
    public readonly syncFileManager: ISyncFileManager;
    public readonly copyPasteImageService: IDynamicService<ICopyPasteImageService>;

    public constructor(
        public readonly uiDataService: IUiDataService,
        public readonly viewableServiceLayer: IBaseViewableServiceLayer,
    ) {
        this.undoRedoService = new UndoRedoService();

        this.menuManager = new MenuManager({});
        this.menuManager.setUiDataServiceDelegate(uiDataService);
        this.menuManager.setSelectionServiceDelegate(this.viewableServiceLayer.selectionService);
        this.menuManager.fontManager = this.viewableServiceLayer.fontManager;
        this.menuManager.setUserPriviledgeServiceDelegate(this.viewableServiceLayer.userPriviledgeService);
        this.menuManager.accessibilityManager = this.viewableServiceLayer.accessibilityManager;
        this.menuManager.setToolbarStateManagerDelegate(this.viewableServiceLayer.toolbarStateManager);

        this.advancedPermissionManager = new AdvancePermissionManager(this.createAdvancedPermissionInject());

        this.syncFileManager = new SyncFileManager();
        viewableServiceLayer.linkManager.setMenuManagerDelegate(this.menuManager);
        this.copyPasteImageService = DynamicServiceLoader.getInstance()
            .registerDynamicService(copyPasteImageServiceDynamicConfig);
        viewableServiceLayer.addonManager.setCopyPasteImageService(this.copyPasteImageService);
        viewableServiceLayer.addonManager.setMenuManagerDelegate(this.menuManager);
        this.copyPasteImageService.onDidInit((copyPasteImageService) => {
            copyPasteImageService.setMenuManagerDelegate(this.menuManager);
        });
    }

    protected createAdvancedPermissionInject(): IAdvancedPermissionInjectable {
        return new AdvancedPermissionInjectable();
    }
}
